<template>
    <el-config-provider :locale="locale">
        <NuxtPwaManifest />
        <NuxtLayout :links="navigationLinks">
            <NuxtLoadingIndicator color="#facc15" errorColor="#dc2626" />
            <NuxtPage />
            <ClientOnly><ProfileAwardNotifier /></ClientOnly>
        </NuxtLayout>
    </el-config-provider>
</template>

<script setup>
import ru from "element-plus/dist/locale/ru.min.mjs";

import {servicePage} from '~/utils/site-seo.mjs';
const seoRoute=useRoute();
useHead({title:()=>/\/edit\/?$/.test(seoRoute.path)?(seoRoute.path.includes('/new/')?'Новый пост':'Редактирование')+' — Умный Огород':'Умный Огород — растения и опыт садоводов'});
useSeoMeta({robots:()=>servicePage(seoRoute.path)?'noindex, follow':undefined,googlebot:'max-image-preview:large, max-snippet:-1, max-video-preview:-1'});

const locale = computed(() => ru);
const client = useUser();
const navigationLinks = useState("navigationLinks");

const settings = useState('settings');

if (client.value?.client_id) {
    const { data } = await useGetProfileSettingsQuery({ 
        variables: {
            id: client.value?.client_id 
        }
    });

    settings.value = data.value.uogorod_users_by_pk.settings;
}



await callOnce(async () => {
        navigationLinks.value = [
            {
                title: "Лента",
                path: "/feed",
                icon: "fluent:feed-28-regular",
                childrens: [{title: "Вопросы и ответы", path: "/questions"}],
            },
            {
                title: "Люди",
                path: "/profiles",
                icon: "icon-park-outline:road-sign-both",
                childrens: [{title: "Рейтинг участников", path: "/profiles/ratings"}],
            },
            {
                title: "Каталог",
                path: "/catalog",
                icon: "fluent-emoji-high-contrast:lotus",
                childrens: [{title: "Рейтинг растений", path: "/tops"}],
            },
            {
                title: "Руководства",
                path: "/manuals",
                icon: "material-symbols:menu-book-outline-rounded",
            },
            {
                title: "Помощь",
                path: "/help/info",
                class: "mt-auto border-t pt-4",
                icon: "vector-help",
                childrens: [
                    {
                        title: "Шаблоны дневника",
                        path: "/help/download",
                    },
                    {
                        title: "Первые шаги",
                        path: "/help/start",
                    },
                    {
                        title: "Электронный дневник",
                        path: "/help/dnevnik-sadovoda",
                    },
                    {
                        title: "Печать своего журнала",
                        path: "/help/print",
                    },
                    {
                        title: "Задать вопрос",
                        path: "/help/contact",
                    },
                ],
            }
        ];
});
</script>
